import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

interface Group {
    value?: string;
    viewValue?: string;
    latLon?: { latitude: number | null, longitude: number | null };
    sensors?: any[];
    latLonList?: any[];
}

@Injectable({ providedIn: 'root' })
export class GroupsComService {

    private groupsPrivate$: BehaviorSubject<Group[]> = new BehaviorSubject([])

    constructor() { }

    public setGroups(groups: Group[]) {
        return this.groupsPrivate$.next(groups)
    }

    public get getGroups(): Observable<Group[]> {
        return this.groupsPrivate$.asObservable()
    }
}

